import Vue from "vue"
import Vuetify from "vuetify/lib/framework"

import CarouselIndicator from "@/components/CarouselIndicator.vue"

Vue.use(Vuetify)

export default new Vuetify({
  theme: {
    dark: false,
    default: "light",
    options: {},
    themes: {
      light: {
        primary: "#004594",
        secondary: "#424242",
        accent: "#82B1FF",
        error: "#FF5252",
        info: "#2196F3",
        success: "#4CAF50",
        warning: "#FB8C00",
      },
    },
  },
  icons: {
    iconfont: "mdi",
    values: {
      "wbc-water": { component: CarouselIndicator },
    },
  },
})
